import React from 'react';
import type { GroupContext } from '../types';

interface ExtensionInfoPageProps {
  t: (key: string, params?: Record<string, any>) => string;
  groupContext: GroupContext;
  onContinue: () => void;
}

const ExtensionInfoPage: React.FC<ExtensionInfoPageProps> = ({ t, groupContext, onContinue }) => {
  const activeMembers = (groupContext.members || []).filter(m => m.active);
  const activeLockedMembers = activeMembers.filter(
    m => m.memberType === 'LOCKED_INITIAL'
  ).length;
  const activeAddedLater = activeMembers.filter(
    m => m.memberType === 'ADDED_LATER'
  ).length;
  const configuredMaxAdditional = groupContext.group.maxAdditionalGuests ?? 0;
  const maxTotalGuests = groupContext.group.maxTotalGuests ?? Number.MAX_SAFE_INTEGER;
  // The effective number of guests that can still be added is bounded by
  // both the additional-guest limit and the overall group-size limit.
  const remainingByAdditionalLimit = Math.max(0, configuredMaxAdditional - activeAddedLater);
  const remainingByTotalLimit = Math.max(0, maxTotalGuests - activeMembers.length);
  const maxAdditional = Math.min(remainingByAdditionalLimit, remainingByTotalLimit);
  const currentTable = groupContext.group.currentTableId || '-';

  return (
    <div className="info-page">
      <div className="info-box">
        <p className="info-title">{t('extensionInfoTitle') || 'Reservierung erweitern oder Tisch wechseln'}</p>
        <p>{t('extensionInfoIntro') || 'Sie sind als  erneut angemeldet. Folgende Optionen stehen Ihnen zur Verfügung:'}</p>

        <ul className="info-list">
          <li>{t('extensionInfoCurrentTable', { table: currentTable }) || `Aktueller Tisch: ${currentTable}`}</li>
          <li>{t('extensionInfoConfirmedMembers', { count: activeLockedMembers }) || `Bereits bestätigte Teilnehmer: ${activeLockedMembers}`}</li>
          <li>{t('extensionInfoAdditionalSlots', { count: maxAdditional }) || `Maximal zusätzliche Gäste: ${maxAdditional}`}</li>
        </ul>

        <p><b>{t('extensionInfoActionTitle') || 'Was Sie jetzt tun können:'}</b></p>
        <ol className="info-list">
          <li>{t('extensionInfoAction1') || 'Weitere Gäste per Buchungscode hinzufügen.'}</li>
          <li>{t('extensionInfoAction2') || 'Wenn am aktuellen Tisch genügend Plätze frei sind, werden neue Gäste automatisch zugewiesen.'}</li>
          <li>{t('extensionInfoAction3') || 'Wenn der aktuelle Tisch nicht ausreicht, wählen Sie einen neuen Tisch für die gesamte Gruppe.'}</li>
          <li>{t('extensionInfoAction4') || 'Mit "Erweiterung bestätigen" speichern Sie die Anpassung verbindlich.'}</li>
        </ol>

        <p><b>{t('extensionInfoImportantTitle') || 'Wichtig:'}</b></p>
        <ul className="info-list">
          <li>{t('extensionInfoImportant1') || 'Bereits bestätigte Gruppenmitglieder bleiben Teil der Gruppe.'}</li>
          <li>{t('extensionInfoImportant2') || 'Bei einem Tischwechsel wird die gesamte Gruppe umgezogen.'}</li>
          <li>{t('extensionInfoImportant3') || 'Falls kein passender Tisch verfügbar ist, wenden Sie sich bitte an das Veranstaltungsteam.'}</li>
        </ul>

        <button className="login-button info-continue-btn" onClick={onContinue}>
          {t('extensionInfoContinue') || 'Erweiterung starten'}
        </button>
      </div>
    </div>
  );
};

export default ExtensionInfoPage;
